import React from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import { addSuffix, formatPhone, generateId, shortHandDate, statusColors } from '../../utility/functions';
import Dot from '../../Dot';
import Table from '../../table/Table';
import LinkTo from '../../forms/LinkTo';
import GetState from '../../GetState';
import Button from '../../forms/Button';
import ExpressPassForm from './ExpressPassForm';
import { IsAuthorized, userRoles } from '../../RoleProtected';
import NoteToolTip from '../../NoteToolTip';
import Row from '../../layout/Row';
import ModalFactory from '../../Modal';
import UserNotes from '../../processors/UserNote';

const Users = ({ ...props }) => {

    const [data, _, setDate] = GetState(QuestRoute.expressPass.users);
    const isAuthorized = IsAuthorized(userRoles.viewCustomers);

    const keys = {
        accountId: 'loyaltyAccountId',
        name: 'accountName',
        phoneNumber: 'phoneNumber',
        members: 'members',
        activeMembers: 'activeMembers',
        status: 'status',
        recurring: 'recurringBilling',
        cycle: 'billingCycle',
        billingDay: 'billingDay',
        billingAttempt: 'lastBillingAttempt',
        lastInvoice: 'lastInvoice',
    }

    const addNew = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Add a New User',
            body: <ExpressPassForm id={id} />
        })
    }

    const tableConfig = {
        data: data,
        controls: [<Button roles={userRoles.editCustomers} onClick={addNew}>Add New</Button>],
        headers: [
            {
                label: 'Account Name',
                propKey: keys.name,
            }, {
                label: 'Phone Number',
                propKey: keys.phoneNumber,
            }, {
                label: 'Members (Active)',
                propKey: keys.members,
            }, {
                label: 'Status',
                propKey: keys.status,
                options: true,
            }, {
                label: 'Recurring Billing',
                propKey: keys.recurring,
                options: true,
            }, {
                label: 'Billing Cycle',
                propKey: keys.cycle,
                options: true,
            }, {
                label: 'Billing Day',
                propKey: keys.billingDay,
                // options: true,
            }, {
                label: 'Billing Attempt',
                propKey: keys.billingAttempt,
                type: 'date'
            }, {
                label: 'Last Invoice',
                propKey: keys.lastInvoice,
                type: 'date'
            },
        ],
        quickSort: [
            {
                label: 'Active Users',
                propKey: keys.status,
                query: 'Active',
                color: '#21D59B'
            }, {
                label: 'Credit Hold',
                propKey: keys.status,
                query: 'CreditHold',
                color: '#bf0d14'
            }, {
                label: 'End Billing Pending',
                propKey: keys.status,
                query: 'EndBillingPending',
                color: '#ffa500'
            }
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>
                    <Row>
                        <NoteToolTip
                            onClick={() => ModalFactory.show({ title: `${e.accountName}'s Notes`, body: <UserNotes customerId={e.customerId} dataSet={data} updateDataSet={setDate} /> })}
                            icon={e.note ? 'pencil' : 'plus'}
                            note={e.note}
                        />
                        {isAuthorized ?
                            <LinkTo
                                target='_blank'
                                loyaltyAccountId={e[keys.accountId]}
                            >{e[keys.name]}</LinkTo> : <div>{e[keys.name]}</div>}
                    </Row>
                </td>
                <td>{formatPhone(e[keys.phoneNumber])}</td>
                <td>{e[keys.members]} ({e[keys.activeMembers]})</td>
                <td>
                    <Row>
                        <Dot color={statusColors[e[keys.status]]} />
                        <span>
                            {e[keys.status]}
                        </span>
                    </Row>
                </td>
                <td>{e[keys.recurring]}</td>
                <td>{e[keys.cycle]}</td>
                <td>{addSuffix(e[keys.billingDay])}</td>
                <td>{shortHandDate(e[keys.billingAttempt])}</td>
                <td>{shortHandDate(e[keys.lastInvoice])}</td>
            </tr>
        )
    }

    return (<Table config={tableConfig} />);
}

export default Users;